export default Object.freeze({
  PAYMENT_VERIFICATION_ERROR: 'PAYMENT_VERIFICATION_ERROR',
  EXPIRED_CARD: 'EXPIRED_CARD',
  MISSING_SESSION_DATA_HPP_PARAMETERS: 'MISSING_SESSION_DATA_HPP_PARAMETERS',
  MISSING_SESSION_DATA_PROFILE_CREATION_SESSION: 'MISSING_SESSION_DATA_PROFILE_CREATION_SESSION',
  MISSING_SESSION_DATA_VBV_PARAMETERS: 'MISSING_SESSION_DATA_VBV_PARAMETERS',
  MISSING_SESSION_DATA_VBV_SESSION: 'MISSING_SESSION_DATA_VBV_SESSION',
  PSP_ERROR: 'PSP_ERROR',
  VBV_FAILURE: 'VBV_FAILURE',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
  TIMEOUT: 'TIMEOUT',
});
